import { postRequest } from 'cupshe-axios'
import { message } from 'ant-design-vue'
import axios from 'axios'
/**
 * 文件下载
 * @param {*} url
 * @param {*} params
 * @param {*} option
 */
export const downloadFile = (url, params, option = {}) => {
  return new Promise((resolve, reject) => {
    postRequest(url, params, {
      ...option,
      ...{
        responseType: 'blob'
      }
    })
      .then(res => {
        // 创建类文件对象 type需指定为文件的mime类型：application/force-download 通用设置
        const blob = new Blob([res], {
          type: res.type
        })
        const archor = document.createElement('a')
        //  将blob实例创建成一个链接
        const href = URL.createObjectURL(blob)
        archor.setAttribute('href', href)
        archor.setAttribute('download', option.fileName || new Date().getTime()) //指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
        document.body.appendChild(archor)
        archor.click()
      })
      .catch(error => {
        alert('下载失败')
        reject(error)
      })
  })
}
export const downloadFileNew = async (url, name) => {
  if (url) {
    const archor = document.createElement('a')
    archor.setAttribute('href', url)
    name ? archor.setAttribute('download', name) : ''
    document.body.appendChild(archor)
    archor.click()
  } else {
    message.warn({
      content: '无导出资源',
      top: '100px',
      maxCount: 1,
      duration: 2
    })
  }
}
export const downloadImg = async (file, errorInfo = '导出失败') => {
  const { ossUrl: url, ossName: name, type, ossType } = file
  const suffix = [
    'ai',
    'prj',
    'webp',
    'psd',
    'dxf',
    'rul',
    'xlsx',
    'excel',
    // 'pdf',
    'docx',
    'doc'
  ]
  const fileType = url.substring(url.lastIndexOf('.') + 1)
  if (suffix.includes(fileType)) {
    const a = document.createElement('a')
    a.setAttribute('href', url)
    a.setAttribute('target', '')
    a.setAttribute('download', '')
    a.click()
    return
  }
  const exclude = ['cdn-review.cupshe.com']
  const headers = {
    'Content-Type': 'multipart/form-data'
  }
  let domain = url.split('/')

  if (domain[2]) {
    domain = domain[2]
  } else {
    domain = '' //如果url不正确就取空
  }
  if (!exclude.includes(domain)) {
    headers['token'] = localStorage.getItem('token')
  }

  try {
    const response = await axios({
      methods: 'get',
      headers,
      url: url.replace('https:', window.location.protocol),
      responseType: 'blob'
    })
    const blob = await new Blob([response.data], {
      type: type || ossType || 'image/png'
    })
    // 创建隐藏的可下载链接
    const objectUrl = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    // 地址
    a.href = objectUrl
    // 修改文件名
    a.download = name || getFileName(url)
    // 触发点击
    document.body.appendChild(a)
    a.click()
    // 移除
    window.URL.revokeObjectURL(blob)
    setTimeout(() => document.body.removeChild(a), 1000)
  } catch (error) {
    message.error(errorInfo)
  }
}
export const getFileName = url => {
  if (url.indexOf('/') > 0) {
    if (url.indexOf('?') > 0) {
      url = url.split('?')[0]
    }
    //如果包含有"/"号 从最后一个"/"号+1的位置开始截取字符串
    return url.substring(url.lastIndexOf('/') + 1, url.length)
  }
  return ''
}
export const handerImageURL = (url, option) => {
  let suffix = '?x-oss-process=image/format,webp'
  if (option.w || option.h) {
    suffix += `/resize${option.w ? ',w_' + option.w : ''}${
      option.h ? ',h_' + option.h : ''
    }`
  }
  if (option.q) {
    suffix += `/quality,q_${option.q}`
  }
  return `${url}${suffix}`
}
